// extracted by mini-css-extract-plugin
export default {"card":"DiscountPresetCard_card__Dfkse","body":"DiscountPresetCard_body__iiV1C","name":"DiscountPresetCard_name__f4s5d","actions":"DiscountPresetCard_actions__EAGTd"};